import React from "react";
import { useFormOrchestrator } from "../../FormContext/useFormContext";
import CustomCardList from "@components/PatientForms/common/CustomCardList";
import { FormField } from "@components/FormEngine/types";
import { CategoryType } from "../../../../types/PatientFormTypes";
import { z } from "zod";

const familyFields: FormField[] = [
  {
    type: "select",
    name: "relationship",
    label: "Relationship",
    options: [
      "Mother",
      "Father",
      "Sister",
      "Brother",
      "Son",
      "Daughter",
      "Grandmother",
      "Grandfather",
      "Aunt",
      "Uncle",
      "Cousin",
      "Other",
    ].map(option => ({ label: option, value: option })),
    rule: z.string().min(1, "Please select a relationship")
  },
	{
    type: "radio",
    name: "deceased",
    title: "Deceased",
		fieldProps: { 
			sx: { backgroundColor: "background.default", flexDirection: "row" },
      options: [
        { value: "No", label: "Alive" },
        { value: "Yes", label: "Deceased" },
				{ value: "Unknown", label: "Unknown" }
      ]
    },
    rule: z.string().min(1, "Please select an option"),
  },
  {
    type: "numeric",
    name: "age",
    label: "Age",
    fieldProps: {
      min: 0,
      max: 120,
			decimalScale: 0,
    },
  },
	{
		type: "input",
		name: "description",
		label: "Describe the condition",
	}
];

const newFamilyMember = {
  relationship: "",
  age: "",
  deceased: "No",
  description: "",
};

export const FamilyList: React.FC = () => {
  const { saveCategoryData } = useFormOrchestrator();
  const category: CategoryType = "familyHistory";

  return (
    <CustomCardList
      name="familyMedicalConditions"
      label="Family Members"
      addButtonText="Family Member"
      cardFields={familyFields as any}
      category={category}
      onSaveCategoryData={saveCategoryData}
      newItemTemplate={newFamilyMember}
    />
  );
};

export default FamilyList;
